import styled, { css } from 'styled-components';

export const Section = styled.div(
  ({ theme }) => css`
    padding-left: ${theme.sz.s6};
    padding-right: ${theme.sz.s6};
  `,
);

export const Content = styled.div(
  () => css`
    max-width: 1152px;
    margin-left: auto;
    margin-right: auto;
  `,
);
